import Component from '../Component';

class Block extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.children.forEach((child) => {
			child.setRefs(this.refs);
			child.componentDidMount();
		});
	}

	render() {
		return (`
            <div class="layerPanel__block ${this.props.blockClassName ?? ''}">
                <span class="layerPanel__heading">${this.props.headingText}</span>
                <div class="layerPanel__control ${this.props.controlClassName}">
                    ${this.children.map((child) => {
				return child.render();
			}).join('')}
                </div>
            </div>`
		);
	}
}

export default Block;